<script setup lang="ts">
import { FramingType, ShippingType } from "mws-ts-v2-sdk";

defineProps<{
  shippingType: ShippingType;
  framingStatus: FramingType;
}>();
</script>

<template>
  <div
    class="text-platform-text-2"
    data-test="expandable-shipping-description"
  >
    <slot />
    <template v-if="shippingType === ShippingType.FreeShipping">
      <I18nT
        scope="global"
        keypath="product.description.freeShippingDescription"
        tag="p"
        data-test="product-description-free-shipping"
      >
        <template #PLACEHOLDER_customerService>
          <BaseCustomerSupportLink class="lowercase">
            {{ $t("common.customerService") }}
          </BaseCustomerSupportLink>
        </template>
      </I18nT>
    </template>
    <template v-else-if="shippingType === ShippingType.PaidShipping">
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="framingStatus === FramingType.Framed"
        v-html="
          $t('product.description.paidShippingDescription.frameDescription')
        "
      />
      <!-- eslint-enable vue/no-v-html -->

      <div
        v-else
        class="flex flex-col gap-4"
      >
        <p>
          {{
            $t("product.description.paidShippingDescription.generalDescription")
          }}
        </p>
        <p>
          {{
            $t(
              "product.description.paidShippingDescription.generalDescriptionVat",
            )
          }}
        </p>

        <div>
          <p>
            {{
              $t(
                "product.description.paidShippingDescription.criteriaDescription",
              )
            }}
          </p>
          <p>
            {{
              $t(
                "product.description.paidShippingDescription.criteriaTitleFreeShipping",
              )
            }}
          </p>

          <strong>
            {{
              $t(
                "product.description.paidShippingDescription.bundlingCriteriaTitleNote",
              )
            }}
          </strong>

          <ul class="list-disc ml-4">
            <li>
              {{
                $t(
                  "product.description.paidShippingDescription.bundlingCriteria1",
                )
              }}
            </li>
            <li>
              {{
                $t(
                  "product.description.paidShippingDescription.bundlingCriteria2",
                )
              }}
            </li>
            <li>
              {{
                $t(
                  "product.description.paidShippingDescription.bundlingCriteria3",
                )
              }}
            </li>
            <li>
              {{
                $t(
                  "product.description.paidShippingDescription.bundlingCriteria4",
                )
              }}
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>
